export default "__VITE_ASSET__CRnmuizy__"